<template>
  <section class="page-container grid-container" v-if="loaded">
    <div class="grid-container wizard">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>

        <section>
            <div class="grid-x grid-margin-x">
                <div v-if="task && task.taskStatus !== 'SuccessfullyCompleted'" class="cell small-12">
                    <h1 class="text-2xl font-bold">Pension Provider Delegation</h1>
                    <p>To manage your workplace pension contributions and employee enrolments, we need delegate access to your auto-enrolment pension account.</p>
                    <p>This access allows us to:
                        <ul>
                        <li>Enrol and manage new employees in your pension scheme.</li>
                        <li>Submit and reconcile contribution schedules on your behalf.</li>
                        <li>Retrieve opt-out notices and manage employee pension statuses.</li>
                        </ul>
                    </p>
                    <br/>
                    <h4>How to grant delegate access:</h4>
                    <p>
                        <ul>
                            <li>Log in to your {{providerInfo.displayName}} employer portal.</li>
                            <li>{{providerInfo.delegationDescription}}</li>
                        </ul>

                    </p>
                    <p>Once you have completed the authorisation, please return to this page and click the "Confirm" button below.</p>

                    <label class="custom-check">
                        <input
                            type="checkbox"
                            v-model="isChecked"
                        >I confirm I have followed the instructions to authorise Qtac access to my pensions account<span class="checkmark"></span>
                    </label> 

                    <br/>
                    <a
                        class="btn btn-primary"
                        @click="markTaskAsComplete"
                        :class="{ disabled: !isChecked }"
                        :aria-disabled="!isChecked"
                        :tabindex="!isChecked ? -1 : 0"
                        @keydown.enter.prevent="isChecked && markTaskAsComplete()"
                        :style="{ pointerEvents: !isChecked ? 'none' : 'auto', opacity: !isChecked ? 0.6 : 1 }"
                    >
                        Confirm
                    </a>

                </div>
                <div v-else-if="error" class="cell small-12">
                        <h1 class="text-2xl font-bold">Pension Provider Alignment</h1>
                        <p v-html="errorString"></p>
                        <button class="btn btn-secondary" @click="router.back()">Return to Tasks</button>
                </div>
                <div v-else class="cell small-12">
                    <h1 class="text-2xl font-bold">Pension Provider Delegation Complete</h1>
                    <p>Thanks for granting us delegate access to your pension provider account.</p>
                    <p>We will now be able to manage your pension submissions.</p>
                    <br/>
                              <button class="btn btn-secondary" @click="router.back()">Return to Tasks</button>
                </div>
            </div>
        </section>


</div>


  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import supportedPensionProviders from '@/helpers/arrays/supportedPensionProviders.js';
import { useProjectStore } from '@/stores/project.js'


const router  = useRouter()
const route = useRoute();
const loaded = ref(true);
const project = useProjectStore();

const taskId = route.params.taskId;
const task = ref(null);

const error = ref(false);

const isChecked = ref(false);
const providerInfo = ref({ displayName: '', delegationDescription: '' });

import { getDataCollectionTask, putDataCollectionTask, getDataCollectionTasks } from '@/services/implementationmanagement.api';
const errorString = ref('An error has occurred. Please contact your Qtac account manager.');

const markTaskAsComplete = async () => {
    try {

        var payload = {
            version: 1,
            dataJson: "",
            schemaName: "PensionProviderAgentDelegation",
            taskId: taskId,
            taskStatus: "SuccessfullyCompleted"
        }

        var response = await putDataCollectionTask(taskId, payload);

        if (response.status !== 200) {
            error.value = 'Error saving data. Please contact your Qtac account manager.';
            return false;
        }

        router.back();

    } catch (e) {
        error.value = true;
    }
};

onMounted(async () => {

    try {
        var delegationTask = await getDataCollectionTask(taskId);

        var allDelegationTasks = (await getDataCollectionTasks(project.projectId)).data;
        var aeDataJson = allDelegationTasks.find(t => t.schemaName === "CompanyAutoEnrolment").dataJson;
        

        if(aeDataJson == null || aeDataJson == "") {
            error.value = true;
            errorString.value = "Before you're able to configure your pension provider, please complete the auto-enrolment questionnaire task.";
            loaded.value = true;
            return;
        }

        const pensionProviderName = JSON.parse(aeDataJson).pensionProviderName.replace(/['\s]/g, '');

        providerInfo.value = supportedPensionProviders.find(p => p.name === pensionProviderName);

        if(!providerInfo.value) {
            error.value = true;
            errorString.value = "<p>The pension provider that your company operates is not currently supported.</p> <p>Your Qtac account manager will be in touch to discuss how we can assist you with your pension provider reporting obligations.</p>";
            loaded.value = true;
            return;
        }

        if(delegationTask.status !== 200 || delegationTask.data === null || delegationTask.data === undefined) {
            error.value = errorString;
            return null;
        }

        task.value = delegationTask.data;

    } catch (err) {
        error.value = errorString;
        console.error(err);
    }

loaded.value = true;
})

</script>

